import { useTheme } from "@mui/material";

interface IconTransformProps {
  img?: string;
  size?: string;
  severity?: number;
  editMode?: boolean;
}

const IconTransform = ({
  img = "",
  size = "24px",
  severity,
  editMode,
}: IconTransformProps) => {
  const theme = useTheme();

  let src = img;

  if (src?.includes("svg")) {
    const svgString = atob(src.split("base64,")[1]);
    const container = document.createElement("div");
    container.innerHTML = svgString;
    const svgElement = container.querySelector("svg");

    if (svgElement) {
      svgElement.style.fill =
        severity === 5 && !editMode ? "#FFFFFF" : theme.palette.text.primary;

      svgElement.style.width = size;
      svgElement.style.height = "auto";
      src = "data:image/svg+xml;base64," + btoa(container.innerHTML);
    }
  }

  return <img src={src} width={size} height="auto" alt="" />;
};

export default IconTransform;
